import { List, Paper, makeStyles } from "@material-ui/core";
import { FindInPage } from "@material-ui/icons";
import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ItemsState } from "../../redux/state";
import { ListItem } from "@ofqual/portal-components/components/List/ListItem";
import {
  formatUtcDate,
  standardDateFormats,
} from "@ofqual/portal-core/core/utils/dateUtils";
import { LcmStatus } from "../../domain/LcmModel";

const SEARCH_STATE_KEY = "search";

const useStyles = makeStyles((theme) => ({
  active: {
    ...theme.list.itemPrimary,
  },
}));

export const ItemsList: React.FC<{ state: ItemsState }> = ({ state }) => {
  const classes = useStyles();

  const { response } = state;
  const history = useHistory();
  const { pathname, search } = useLocation();
  const navigate = (id: string) =>
    history.push(`${pathname}/${id}`, { [SEARCH_STATE_KEY]: search });

  return (
    <>
      <Paper>
        <List disablePadding>
          {response.data.map((item) => (
            <React.Fragment key={item.id}>
              <ListItem
                button
                alignItems="flex-start"
                onClick={() => navigate(item.id)}
                divider
                className={classes.active}
                data-test="row"
                Icon={FindInPage}
                primaryText={item.caseTitle}
                reference={item.referenceNumber}
                secondaryDetails={[
                  {
                    heading: "Assigned",
                    value:
                      item.assignedTo !== null
                        ? item.assignedTo.length > 1
                          ? `${item.assignedTo[0]} + ${
                              item.assignedTo.length - 1
                            } other(s)`
                          : `${item.assignedTo[0]}`
                        : "Nobody",
                  },
                  {
                    heading: "Date Received",
                    value:
                      item.assignedCreatedDate === null
                        ? "n/a"
                        : formatUtcDate(
                            item.assignedCreatedDate,
                            standardDateFormats.DATE
                          ),
                  },
                  {
                    heading: "Date Created",
                    value: `${formatUtcDate(
                      item.createdDate,
                      standardDateFormats.DATE_TIME
                    )}`,
                  },
                  {
                    heading: "Date Due",
                    value:
                      item.dueDate === null
                        ? "Not given"
                        : formatUtcDate(
                            item.dueDate,
                            standardDateFormats.DATE
                          ),
                  },
                ]}
                chipTexts={[
                  {
                    text: `Status: ${LcmStatus[item.status]}`,
                  },
                ]}
              ></ListItem>
            </React.Fragment>
          ))}
        </List>
      </Paper>
    </>
  );
};
